import {UserFlag} from 'common/report/constants';

import {createSimpleClient, Store} from './store';

const URL = `/api/app/me/user-flags`;

const userFlagsClient = createSimpleClient(() => URL);

export const userFlagsStore = new Store<Record<UserFlag, number>>({
  apiClient: userFlagsClient,
  defaultValue: null,
  name: `user-flags`,
});
